<template>
  <div
    :class="{
      'relative z-[2] mx-auto flex w-[60%] flex-wrap justify-center lg:justify-between': true,
    }"
  >
    <template
      v-for="persona in personas"
      :key="persona._key"
    >
      <div
        :class="{
          'persona-option': true,
          'hekate-input-selected hekate-input-highlighted': selectedValue === persona.personaValue,
        }"
        :hekate-input-value="persona.personaValue"
        hekate-input-field-name="schoolLevel"
        @click="emit('select', persona.personaValue)"
      >
        <input
          :id="persona.personaValue"
          type="radio"
          name="persona"
          :checked="selectedValue === persona.personaValue"
        />
        <label
          :for="persona.personaValue"
          :class="{
            'ml-1 break-words text-base font-bold leading-7 md:text-xl': true,
          }"
          >{{ persona.personaName }}</label
        >
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { UssPersonaEduList } from '~/sanity/types';

defineProps<{ personas: UssPersonaEduList; selectedValue?: string }>();
const emit = defineEmits<{ select: [value: string] }>();
</script>
